import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface Facility {
  id: string;
  name: string;
  district: string;
  serviceType: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class FacilityService {
  private mockFacilities: Facility[] = [
    { id: 'f1', name: 'Lusaka Youth Hub', district: 'Lusaka', serviceType: 'PrEP Services', description: 'Youth-friendly clinic offering private guidance and PrEP information.' },
    { id: 'f2', name: 'Ndola Health Centre', district: 'Ndola', serviceType: 'PrEP Services', description: 'Confidential PrEP services and referral support.' },
    { id: 'f3', name: 'Kitwe Support Clinic', district: 'Kitwe', serviceType: 'PrEP Services', description: 'Private PrEP consultation.' },
    { id: 'f4', name: 'Livingstone Care', district: 'Livingstone', serviceType: 'PrEP Services', description: 'Youth-friendly PrEP services.' },
    { id: 'f5', name: 'Chipata Youth Clinic', district: 'Chipata', serviceType: 'PrEP Services', description: 'PrEP info and guidance.' },
    { id: 'f6', name: 'Lusaka Nurse Line', district: 'Lusaka', serviceType: 'Talk to a nurse', description: 'Private questions before visiting a clinic.' }
  ];

  constructor() { }

  getDistricts(): Observable<string[]> {
    return of(['Lusaka', 'Ndola', 'Kitwe', 'Livingstone', 'Chipata']);
  }

  getServices(): Observable<string[]> {
    return of(['PrEP Services', 'Talk to a nurse', 'Clinic finder', 'Guardian information']);
  }

  findFacilities(district: string, serviceType: string): Observable<Facility[]> {
    const results = this.mockFacilities.filter(f => 
      (f.district === district || !district) && 
      (f.serviceType === serviceType || !serviceType)
    );
    return of(results);
  }
}
